import RevxFlexLayout from 'components/RevxFlexLayout';
import { RevxRadioProps } from 'components/RevxRadio';
import { useEffect, useMemo, useState } from 'react';
import { ConfigSvcProps } from '..';
import CommonJobSvcBorder from '../common/CommonJobSvcBorder';
import CommonJobSvcCotainer from '../common/CommonJobSvcCotainer';
import CommonJobSvcInstructions from '../common/CommonJobSvcInstructions';
import CommonJobSvcMessage from '../common/CommonJobSvcMessage';
import CommonJobSvcName from '../common/CommonJobSvcName';
import CommonJobSvcOption from '../common/CommonJobSvcOption';
import CommonJobSvcSpec from '../common/CommonJobSvcSpec';
import CommonQuantityPerBundle from '../common/CommonQuantityPerBundle';
import { useHideSvc } from '../hook/useHideSvc';
import { useHideSvcContainer } from '../hook/useHideSvcContainer';

const PaddingAdhesive = (props: ConfigSvcProps) => {
  const { formCache, isRequired, form, jobOptionSvc, sku, spec, id } = props;
  const hideSvc = useHideSvc(props);
  const hideSvcContainer = useHideSvcContainer(props);
  const [disabledOption, setDisabledOption] = useState<string>('');

  const disabledAmount = useMemo(() => {
    return sku.revxId === 552 || sku.revxId === 584 || true;
  }, [sku.revxId]);

  useEffect(() => {
    // if (!formCache?.[id]) {
    //   form.resetFields();
    //   form.setFieldsValue(formCache);
    // }
    setTimeout(() => {
      if (formCache?.[38]?.name?.includes('Carbonless Adhesive')) {
        setDisabledOption(formCache?.[38]?.['Adhesive Edge']);
        // if (
        //   formCache[38]?.['Adhesive Edge'] ===
        //     formCache[39]?.['Padding Edge'] &&
        //   !isRequired
        // ) {
        //   const formData = form.getFieldsValue();
        //   formData[39]['Padding Edge'] = jobOptionSvc.options
        //     ?.find((option) => {
        //       return option.label === 'Padding Edge';
        //     })
        //     ?.values.find((item) => item !== disabledOption);
        //   form.setFieldsValue(formData);
        // }
      } else {
        setDisabledOption('');
      }
      // setDisabledOption('');
      if (disabledAmount && formCache?.[id]?.['name']) {
        const formData = form.getFieldsValue();
        if (!formData[39]) {
          formData[39] = {};
        }
        formData[39]['quantityPerBundle'] = spec?.pageCount;
        form.setFieldsValue(formData);
      }
    }, 1000);
    // eslint-disable-next-line
  }, [
    formCache,
    disabledOption,
    form,
    isRequired,
    jobOptionSvc.options,
    sku.revxId,
    spec?.pageCount,
    disabledAmount,
  ]);

  const customerRadioProps = (
    labelArr: string[],
    disabled?: boolean,
    label?: string
  ): RevxRadioProps => {
    return {
      disabled: disabled,
      outSideRevxLayoutProps: {
        align: 'top',
        justify: 'left',
        wrap: 'wrap',
        className: 'jobconfig-jobOption-content-outSideOption-default',
        style: {
          paddingBottom: 0,
          marginTop: 8,
        },
      },
      inSideRevxLayoutProps: {
        align: 'top',
        justify: 'left',
        className: 'jobconfig-jobOption-content-inSideOption-default',
        style: {
          marginRight: 31,
        },
      },
      options:
        labelArr?.map((item) => {
          return {
            value: item,
            children: <span>{item}</span>,
            disabled:
              label === 'Padding Edge' &&
              disabledOption === item &&
              !isRequired,
          };
        }) || [],
    };
  };
  return (
    <>
      <div style={hideSvc}>
        <RevxFlexLayout align="top" justify="justify-start">
          <CommonJobSvcName {...props} />
          <div>
            <CommonJobSvcCotainer {...props}>
              <CommonJobSvcSpec {...props} disabled={hideSvcContainer} />
              <CommonJobSvcOption
                customerRadioProps={customerRadioProps}
                {...props}
                disabled={hideSvcContainer}
              />
              <CommonQuantityPerBundle
                {...props}
                title={'Number of Pages'}
                show={true}
                disabled={hideSvcContainer || disabledAmount}
              />
              <CommonJobSvcInstructions
                {...props}
                disabled={hideSvcContainer}
              />
              <CommonJobSvcMessage {...props} disabled={hideSvcContainer} />
            </CommonJobSvcCotainer>
          </div>
        </RevxFlexLayout>
        <CommonJobSvcBorder />
      </div>
    </>
  );
};

export default PaddingAdhesive;
